
import { leonBio } from './larryBios'
import { leonReviewerReviewHinge, leonReviewerReviewBumble, leonReviewerReviewTinder } from './larryReviewerReviews'

export const leonReviewerProfile = {
  _id: 'leonReviewerProfileId',
  userId: 'leonUserId',
  email: 'leon@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-4-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...leonBio },
  profileReviews: [
    // { ...leonProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...leonReviewerReviewHinge },
    { ...leonReviewerReviewBumble },
    { ...leonReviewerReviewTinder }
  ],
}